module.exports = __webpack_public_path__ + "img/cert.89887bbb.png";